

import { useHead } from '@vueuse/head'
import { pageTitle } from '../state/sidebarLayoutState'
import StockDashboard from "../components/dashboards/StockDashboard.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import { computed , defineComponent } from "vue";
import VButton from './../components/base/button/VButton.vue'
import { mapState } from "vuex";
import store, {ActionTypes} from '../store'


export default defineComponent( {
  name : 'Index' ,
  components : {
    VButton ,
    SidebarLayout,
    StockDashboard,
  },
  beforeRouteEnter() {
    store.dispatch(ActionTypes.FETCH_CURRENT_USER);
  },
  setup(){
    pageTitle.value = 'JB Drax Honoré Dashboard'
    useHead({
      // Can be static or computed
      title: computed(() => pageTitle.value),
    })
  },
  computed: {
    ...mapState(['user'])
  },
})
